import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs/modular/sortable.core.esm.js";
import { LoadingSpinnerHandler } from "@mixins/btnLoading";
import axios from "axios";

export default class extends Controller {
  static targets = ["customFieldWrapper", "possibleValuesInput", "nestedField"];

  possibleValuesInputTargetConnected(target) {
    window.initSelect2(target);
  }

  customFieldWrapperTargetConnected(target) {
    new Sortable(target, {
      handle: ".handle-drag-field",
      dragClass: ".sortable-drag",
      ghostClass: "ghostClass-sortable",
      filter: ".custom-field-being-deleted",
      scroll: true,
      onEnd: function (evt) {
        if (evt.oldIndex == evt.newIndex) {
          return false;
        }

        // Update all of rank's val
        Array.from(target.querySelectorAll("[data-field='rank']")).forEach(
          (e, i) => {
            e.value = i + 1;
          }
        );
      }
    });

    $(target).on("cocoon:after-insert", function (e, evt) {
      $(evt)
        .find("[data-field='rank']")
        .val(target.querySelectorAll("[data-field='rank']").length);
    });
  }

  nestedFieldTargetConnected(element) {
    const bootstrapCollapse = element.querySelector(".custom-field-content");
    bootstrapCollapse.addEventListener("show.bs.collapse", () => {
      const icon = element.querySelector(".custom-field-open-btn .far");
      icon.classList.remove("fa-square-caret-right");
      icon.classList.add("fa-square-caret-down");
    });

    bootstrapCollapse.addEventListener("hide.bs.collapse", () => {
      const icon = element.querySelector(".custom-field-open-btn .far");
      icon.classList.add("fa-square-caret-right");
      icon.classList.remove("fa-square-caret-remove");
    });
  }

  updateLabel({ target }) {
    const field = target.closest(".nested-fields");
    const label = field.querySelector("[data-field='label']");
    label.innerHTML = target.value;
  }

  deleteField({ target }) {
    const field = target.closest(".nested-fields");
    if (field.dataset.status == "archived") {
      const archiveField = field.querySelector("[data-field='is_archived']");
      archiveField.value = 1;

      field
        .querySelector(".custom-field-content-delete")
        .classList.add("d-none");
      field
        .querySelector(".custom-field-restore-btn")
        .classList.remove("d-none");
      field.querySelector(".custom-field-delete").classList.add("d-none");
    } else if (field.dataset.status == "archived") {
      const destroyField = field.querySelector("[data-field='_destroy']");
      destroyField.value = 1;

      field.querySelector(".custom-field-content").classList.add("d-none");
      field
        .querySelector(".custom-field-content-delete")
        .classList.remove("d-none");
      field.classList.add("custom-field-being-deleted");
      field
        .querySelector(".custom-field-restore-btn")
        .classList.remove("d-none");
    } else {
      field.remove();
    }
  }

  restoreField({ target }) {
    const field = target.closest(".nested-fields");

    if (field.dataset.status == "archived") {
      const archiveField = field.querySelector("[data-field='is_archived']");
      archiveField.value = 0;
      field
        .querySelector(".custom-field-content-delete")
        .classList.remove("d-none");
      field.querySelector(".custom-field-restore-btn").classList.add("d-none");
      field.querySelector(".custom-field-delete").classList.remove("d-none");
      return;
    }

    field.querySelector(".custom-field-content").classList.remove("d-none");
    field.querySelector(".custom-field-content-delete").classList.add("d-none");
    field.classList.remove("custom-field-being-deleted");
    field.querySelector(".custom-field-restore-btn").classList.add("d-none");

    if (field.dataset.status == "active") {
      const destroyField = field.querySelector("[data-field='_destroy']");
      destroyField.value = 0; // unset field that indicates to remove it
    }
  }

  showPossibleValuesInput(evt) {
    const nestedField = evt.target.closest(".nested-fields");
    const possibleValuesDisplay = ["select", "multiselect", "radio"].includes(
      evt.target.value
    );

    const possibleValuesInput = nestedField.querySelector(
      ".custom-field-possible-values"
    );

    if (possibleValuesDisplay) possibleValuesInput.classList.remove("d-none");
    else possibleValuesInput.classList.add("d-none");
  }

  previewDialog({ currentTarget, params }) {
    LoadingSpinnerHandler.add(currentTarget);
    currentTarget.disabled = true;

    const formData = new FormData(currentTarget.form);

    axios({
      url: params.url,
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "text/vnd.turbo-stream.html;charset=UTF-8;",
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content
      }
    })
      .then(({ data }) => {
        Turbo.session.receivedMessageFromStream(data);
        requestAnimationFrame(() => {
          currentTarget.disabled = false;
          LoadingSpinnerHandler.remove(currentTarget);
          window.initSelect2();
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  toggleArchivesVisibility() {
    const archives = document.querySelectorAll(
      ".custom-field-form[data-status='archived']"
    );
    let action = "add";
    if (archives[0].classList.contains("d-none")) {
      action = "remove";
    }

    archives.forEach(e => {
      e.classList[action]("d-none");
    });
  }
}
